import { render } from "./blogCatView.vue?vue&type=template&id=156ecd83"
import script from "./blogCatView.vue?vue&type=script&lang=js"
export * from "./blogCatView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__